import React, { useContext, useCallback } from 'react';
import _ from 'lodash';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { ServiceManager } from '@jutro/legacy/services';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';
import metadata from './RevenueComponent.metadata.json5';

import styles from '../MedicalPractitioners.module.scss';
import RevenueBusinessActivitiesComponent from '../subcomponents/RevenueBusinessActivities/RevenueBusinessActivitiesComponent';
import { BreakpointTrackerContext } from '@jutro/legacy/layout';

function RevenueComponent(props) {

    const { submissionVM, updateWizardData, pathUpdated } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const { onValidate } = useValidation('RevenueComponent');
    const modelVM = _.get(submissionVM, pathUpdated)
    const localeService = ServiceManager.getService('locale-service');

    modelVM.value.isValidationReq = true

    const totalAPercentage = () => {
        let totalPercentage = 0;

        if (modelVM.value.revenueBusinessActivitiesDTO.length > 0) {
            modelVM.value.revenueBusinessActivitiesDTO.forEach(data => {
                if (!_.isUndefined(data.claTyp2)) {
                    if (data.claTyp2 === 'A') {
                        if(!_.isUndefined(data.perOfRev3)) {
                            totalPercentage += data.perOfRev3;
                        }                                
                    }
                }
            })
        }

        _.set(modelVM.value, 'totRevClaA6', totalPercentage);

        return totalPercentage
    }

    const totalBPercentage = () => {
        let totalPercentage = 0;

        if (modelVM.value.revenueBusinessActivitiesDTO.length > 0) {
            modelVM.value.revenueBusinessActivitiesDTO.forEach(data => {
                if (!_.isUndefined(data.claTyp2)) {
                    if (data.claTyp2 === 'B') {
                         if(!_.isUndefined(data.perOfRev3)) {
                            totalPercentage += data.perOfRev3;
                        }                          
                    }
                }
            })
        }

        _.set(modelVM.value, 'totRevClaB7', totalPercentage);

        return totalPercentage
    }

    const totalCPercentage = () => {
        let totalPercentage = 0;

        if (modelVM.value.revenueBusinessActivitiesDTO.length > 0) {
            modelVM.value.revenueBusinessActivitiesDTO.forEach(data => {
                if (!_.isUndefined(data.claTyp2)) {
                    if (data.claTyp2 === 'C') {
                         if(!_.isUndefined(data.perOfRev3)) {
                            totalPercentage += data.perOfRev3;
                        }                         
                    }
                }
            })
        }

        _.set(modelVM.value, 'totRevClaC8', totalPercentage);

        return totalPercentage
    }

    const totalDPercentage = () => {
        let totalPercentage = 0;

        if (modelVM.value.revenueBusinessActivitiesDTO.length > 0) {
            modelVM.value.revenueBusinessActivitiesDTO.forEach(data => {
                if (!_.isUndefined(data.claTyp2)) {
                    if (data.claTyp2 === 'D') {
                         if(!_.isUndefined(data.perOfRev3)) {
                            totalPercentage += data.perOfRev3;
                        }                         
                    }
                }
            })
        }

        _.set(modelVM.value, 'totRevForSerRelToAlt10', totalPercentage);

        return totalPercentage
    }

    const totalEPercentage = () => {
        let totalPercentage = 0;

        if (modelVM.value.revenueBusinessActivitiesDTO.length > 0) {
            modelVM.value.revenueBusinessActivitiesDTO.forEach(data => {
                if (!_.isUndefined(data.claTyp2)) {
                    if (data.claTyp2 === 'E') {
                         if(!_.isUndefined(data.perOfRev3)) {
                            totalPercentage += data.perOfRev3;
                        }                          
                    }
                }
            })
        }

        _.set(modelVM.value, 'totRevForSerRelToHea11', totalPercentage);

        return totalPercentage
    }

    
    const sumABC = () => {
        let abcTotal = 0;

        if(!_.isUndefined(modelVM.value.totRevClaA6)) {
            abcTotal += modelVM.value.totRevClaA6

        }

        if(!_.isUndefined(modelVM.value.totRevClaB7)) {
            abcTotal += modelVM.value.totRevClaB7
            
        }

        if(!_.isUndefined(modelVM.value.totRevClaC8)) {
            abcTotal += modelVM.value.totRevClaC8
            
        }

        _.set(modelVM.value, 'totRevForAllCla9', abcTotal);   

        return abcTotal
    }

    const updateRevenueSubComp = () => {
        if(!_.isUndefined(modelVM.value.feeFroAllOfAppOpeLas2)) {
            if(modelVM.value.revenueBusinessActivitiesDTO.length > 0) {
                let index = 0;

                modelVM.value.revenueBusinessActivitiesDTO.forEach(element => {                   
                    if(!_.isUndefined(element.rev4) && !_.isUndefined(element.perOfRev3)) {
                        const updateRevenue = modelVM.value.feeFroAllOfAppOpeLas2.amount !== "" ? ((element.perOfRev3/100) * modelVM.value.feeFroAllOfAppOpeLas2.amount) : 0;
                        const revenueObj = {
                            amount: updateRevenue,
                            currency: localeService.getDefaultCurrencyCode()
                        }
 
                        _.set(modelVM.value.revenueBusinessActivitiesDTO[index], 'rev4', revenueObj);
                        index += 1;
                    }
                })
            }
        }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        feeFroAllOfAppOpeLas2: {
            onchange: updateRevenueSubComp()
        },
        totRevClaA6: {
            disabled: true,
            value: totalAPercentage()
        },
        totRevClaB7: {
            disabled: true,
            value: totalBPercentage()
        },
        totRevClaC8: {
            disabled: true,
            value: totalCPercentage()
        },
        totRevForAllCla9: {
            disabled: true,
            value: sumABC()
        },
        totRevForSerRelToAlt10: {
            disabled: true,
            value: totalDPercentage()
        },
        totRevForSerRelToHea11: {
            disabled: true,
            value: totalEPercentage()
        },
        revenueBusinessActivitiesComponent: {
            data: modelVM.revenueBusinessActivitiesDTO,
            updateWizardData,
            submissionVM,
            sumABC,
            RevenueBusinessActivitiesPath: `${pathUpdated}.revenueBusinessActivitiesDTO`
        }
    };


    const resolvers = {
        resolveCallbackMap: {
            onValidate
        },
        resolveComponentMap: {
            revenueBusinessActivitiesComponent: RevenueBusinessActivitiesComponent
        },
        resolveClassNameMap: styles,
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.componentContent, _.get(submissionVM, pathUpdated), id, path, overrideProps),
        [overrideProps, pathUpdated, submissionVM]
    );

    const handleValueChange = useCallback(
        (value, changedPath) => {
            const fullPath = `${pathUpdated}.${changedPath}`;

            _.set(submissionVM, `${fullPath}`, value);

            updateWizardData(submissionVM);
        },
        [pathUpdated, submissionVM, updateWizardData]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={modelVM}
            // onModelChange={updateWizardData}
            resolveValue={readValue}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

RevenueComponent.propTypes = wizardProps;
export default withRouter(RevenueComponent);
